export { StarHalfStroke as default } from './StarHalfStroke';
